exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-nav {\r\n  background-color: #deedea;\r\n  font-size: 1.1rem;\r\n  -webkit-box-shadow: 0 1px 6px 2px rgba(0,0,0,.3);\r\n          box-shadow: 0 1px 6px 2px rgba(0,0,0,.3);\r\n  position: fixed;\r\n  top: 85px;\r\n  z-index:1;\r\n  width: 100%;\r\n  height: 46px;\r\n}\r\n\r\n.subnav .nav {\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: nowrap;\r\n      flex-wrap: nowrap;\r\n}\r\n\r\n.sub-nav .nav-item .nav-link {\r\n  margin-top: 11px;\r\n}\r\n\r\n.sub-nav .nav-item a,\r\n.sub-nav .nav-item a:link {\r\n  color: #49525a;\r\n  padding: 2px 8px;\r\n}\r\n\r\n.sub-nav .nav-item a:hover {\r\n  border-bottom: 2px solid #84baad;\r\n  cursor: pointer;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .sub-nav {\r\n    font-size: .7rem;\r\n  }\r\n  .sub-nav .nav-item a{\r\n    border-bottom: 1px solid #84baad;\r\n  }\r\n\r\n  .sub-nav .nav-item a,\r\n  .sub-nav .nav-item a:link {\r\n    padding: 2px 0;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/education-and-career/subnav/subnav.component.css
// module id = ../../../../../src/app/components/education-and-career/subnav/subnav.component.css
// module chunks = main